<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10" cy="10" r="8" fill="#7C3AED"/>
<path d="M7 10H13" stroke="white" stroke-width="2" stroke-linecap="round"/>
<path d="M10 7L13 10" stroke="white" stroke-width="2" stroke-linecap="round"/>
<path d="M10 13L13 10" stroke="white" stroke-width="2" stroke-linecap="round"/>
</svg>
